/** Attach source identifiers at click time, including after a native variant change. */
export function buildGuardianInquiry(href, context, variantId, origin, languageRoot) {
  const url = new URL(href, origin);
  if (url.origin !== origin || !/\/pages\/contact\/?$/u.test(url.pathname)) return null;
  const variant = context.variants.find(item => String(item.id) === String(variantId));
  const originalProductUrl = url.searchParams.get('product_url');
  const oldVariantId = url.searchParams.get('variant_id') ||
    (originalProductUrl ? new URL(originalProductUrl, origin).searchParams.get('variant') : null);
  url.pathname = `${languageRoot.replace(/\/$/u, '')}/pages/contact`;
  url.searchParams.set('sku', variant?.sku || '');
  url.searchParams.set('variant_id', String(variantId || ''));
  url.searchParams.set('manufacturer', context.manufacturer);
  url.searchParams.set('product', context.title);
  const productUrl = new URL(context.productUrl, origin);
  if (variantId) productUrl.searchParams.set('variant', String(variantId));
  url.searchParams.set('product_url', productUrl.href);
  if (context.mpnIsSku) url.searchParams.set('mpn', variant?.sku || '');
  else {
    if ((oldVariantId && oldVariantId !== String(variantId)) ||
        (!oldVariantId && String(context.selectedVariantId) !== String(variantId))) url.searchParams.delete('mpn');
  }
  return url.href;
}

if (typeof document !== 'undefined') {
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-guardian-product-inquiry-link], [data-guardian-product-inquiry="20261021"] a');
    if (!(link instanceof HTMLAnchorElement)) return;
    const scope = link.closest('.product-details');
    const source = scope?.querySelector('[data-guardian-inquiry-source]');
    if (!(source instanceof HTMLElement)) return;
    let context;
    try { context = JSON.parse(source.dataset.guardianInquirySource); } catch { return; }
    const selected = scope.querySelector('product-form-component input[name="id"]');
    const variantId = selected?.value || new URL(location.href).searchParams.get('variant') || context.selectedVariantId;
    const href = buildGuardianInquiry(link.href, context, variantId, location.origin, source.dataset.languageRoot);
    if (href) link.href = href;
  }, true);
}
